import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { stockStatus } from '@/lib/format'

const TONES = {
    available: 'bg-[#E6F6EC] text-[#0E6B33]',
    low: 'bg-[#FFF1D6] text-[#8A4B00]',
    out: 'bg-[#FDE7E3] text-[#A3261A]'
}

const DOTS = {
    available: 'bg-[#12A150]',
    low: 'bg-brand-orange',
    out: 'bg-destructive'
}

export const StockBadge: FC<{ stock: number, className?: string, showCount?: boolean }> = ({ stock, className, showCount = false }): ReactNode => {
    const status = stockStatus(stock)

    return (
        <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold', TONES[status.tone], className)}>
            <span className={cn('size-1.5 rounded-full', DOTS[status.tone])} aria-hidden='true' />
            {status.label}
            {showCount && stock > 0 && <span className='font-medium opacity-80'>({stock})</span>}
        </span>
    )
}
